import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { className: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { className: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#disabled-state" }),
  /*#__PURE__*/_createTextVNode(" Disabled State ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { className: "py-5" }, " Disabled state for checkbox. ", -1)
const _hoisted_4 = { className: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Option")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Option")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.checked1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checked1 = $event)),
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.checked2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checked2 = $event)),
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}